module.exports = __webpack_public_path__ + "static/recyclage-f8d4ba14396dc3a7e61d0750fb16c54d.png";